export default __webpack_public_path__ + "static/media/trash-bin.d3cf2fd8.svg";